import { QueryClient } from '@tanstack/react-query';

const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 1000 * 20, // by default cache query results for 20 seconds -- can be overridden by individual queries
    },
  },
});
export default reactQueryClient;
